var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.b(),_vm.className],style:(_vm.styleSizeName),on:{"click":_vm.handleClick}},[(_vm.reload)?_c(_vm.option.is,_vm._b({ref:_vm.id,tag:"component",style:(_vm.styleChartName)},'component',_vm.config,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }